import classnames from "classnames/bind";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.css";
import {
  hideFilterOverlay,
  toggleSecondaryList
} from "../../state/modules/layout/actions";
import {
  getFilterOverlayVisible,
  getSecondaryListIsOpen
} from "../../state/modules/layout/selectors";
import { analyticsRefinementsCloseMobile } from "../../state/modules/analytics/actions";
import TrapFocus from "../../components/TrapFocus";
import Escapable from "../../components/Escapable";

const styleContext = classnames.bind(styles);

const FilterLayout = ({ children }) => {
  const dispatch = useDispatch();
  const isFilterOverlayVisible = useSelector(getFilterOverlayVisible);
  const secondaryListIsOpen = useSelector(getSecondaryListIsOpen);

  const layout = styleContext({
    filterLayout: true,
    showOnMobile: isFilterOverlayVisible
  });

  const handleClick = () => {
    if (isFilterOverlayVisible) {
      dispatch(hideFilterOverlay());
      if (secondaryListIsOpen) {
        dispatch(toggleSecondaryList());
      }
      dispatch(analyticsRefinementsCloseMobile());
    }
  };

  return (
    <aside className={styles.container}>
      <Escapable escapeHandler={handleClick} />
      <div className={layout}>
        <div
          className={styles.grayTapArea}
          onClick={handleClick}
          aria-hidden={true}
        />
        <TrapFocus
          className={styles.filterContainer}
          trapFocus={isFilterOverlayVisible}
        >
          {children}
        </TrapFocus>
      </div>
    </aside>
  );
};

FilterLayout.propTypes = {
  children: PropTypes.node.isRequired
};

FilterLayout.displayName = "FilterLayout";

export default FilterLayout;
